import { Col, Image, Row } from 'react-bootstrap'
import firtStep from '../assets/images/howToOperate/Paso1.png'
import secondStep from '../assets/images/howToOperate/Paso2.png'
import thirdStep from '../assets/images/howToOperate/Paso3.png'
import fourthStep from '../assets/images/howToOperate/Paso4.png'
import fifthStep from '../assets/images/howToOperate/Paso5.png'
import './Info.scss'
import './HowToOperate.scss'
import { useEffect } from 'react'

export default function HowToOperate (){
  useEffect(()=>{
    window.scrollTo(0, 0);
  },[])
  return (
    <div className="info-pages how-to-operate">
      <div className="info-header"></div>
      <div className="page-info-content">
        <div className="page-info-header">
          <div className="title">Cómo Operar</div>
          <div className="subtitle">Opera de manera sencilla, simple y rápida.</div>
        </div>
        <div className="page-info-data">
          <Row>
            <Col>
              <Image src={firtStep} />
            </Col>
            <Col className='step-content'>
              <div className='step-tag'>Paso 1</div>
              <div className='inner-content'>
                <div className='step-title'>Regístrate</div>
                <div className='description'>Una vez que te registres, un representante comercial de LDC revisará tus datos a la brevedad para enviarte la aprobación por correo electrónico avisando que ya estás listo para acceder a la tienda y realizar tu pedido.</div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col className='step-content'>
              <div className='step-tag'>Paso 2</div>
              <div className='inner-content'>
                <div className='step-title'>Ingresá con tus datos</div>
                <div className='description'>Ingresá con tu email y contraseña. Si olvidaste tu contraseña, podés recuperarla acá.</div>
              </div>
            </Col>
            <Col>
              <Image src={secondStep} />
            </Col>
          </Row>
          <Row>
            <Col>
              <Image src={thirdStep} />
            </Col>
            <Col className='step-content'>
              <div className='step-tag'>Paso 3</div>
              <div className='inner-content'>
                <div className='step-title'>Buscá tus productos y agregalos al carrito</div>
                <div className='description'>Buscá tus productos y agregalos al carrito. <br /> Explorá todos los productos que tenemos para tu negocio y agregalos al carrito. Podés elegir la cantidad.</div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col className='step-content'>
              <div className='step-tag'>Paso 4</div>
              <div className='inner-content'>
                <div className='step-title'>Revisá tu carrito de compra</div>
                <div className='description'>Cuando tengas listo tu pedido, revisá los datos y confirmá la Nota de Pedido. Podés agregar observaciones por producto y por pedido.</div>
              </div>
            </Col>
            <Col>
              <Image src={fourthStep} />
            </Col>
          </Row>
          <Row>
            <Col>
              <Image src={fifthStep} />
            </Col>
            <Col className='step-content'>
              <div className='step-tag'>Paso 5</div>
              <div className='inner-content'>
                <div className='step-title'>¡Listo! Tu pedido fue realizado</div>
                <div className='description'>Una vez que lo enviaste, nos pondremos en contacto con vos para coordinar la logística del mismo.</div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}